import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TZ2418Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TZ2418IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_716)">
        <rect width="24" height="18" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V18H24V0H0Z"
          fill="#3195F9"
        />
        <mask
          id="mask0_1813_716"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="18"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V18H24V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_716)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V18L24 0H0Z"
            fill="#73BE4A"
          />
          <path
            d="M-1.62612 19.2529L-0.932157 20.2926L0.107515 19.5986L27.3032 1.44602L28.3429 0.752057L27.6489 -0.287615L25.9834 -2.78283L25.2895 -3.8225L24.2498 -3.12854L-2.94591 15.0241L-3.98559 15.718L-3.29163 16.7577L-1.62612 19.2529Z"
            fill="#272727"
            stroke="#FFD018"
            strokeWidth="2.5"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1813_716">
          <rect width="24" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TZ2418Icon;
